import { Tooltip } from "@mui/material"
import { HeaderLabelWrapper } from "./styles"
import { AiOutlineInfo } from "react-icons/ai"
interface IHeaderLabelProps {
	icons: JSX.Element
	label: string
	tooltip?: string
}
export default function HeaderLabel({
	icons,
	label,
	tooltip,
}: IHeaderLabelProps) {
	return (
		<HeaderLabelWrapper>
			<div className='containerIcon'>{icons}</div>
			<div className='containerLabel'>{label}</div>
			<div className="containerTooltip">
				{tooltip && (
					<Tooltip title={tooltip}>
						<div className=''>
							<AiOutlineInfo />
						</div>
					</Tooltip>
				)}
			</div>
		</HeaderLabelWrapper>
	)
}
